import * as model from './model.js';
import recipeView from './views/recipeView.js';
import searchView from './views/searchView.js';
import resultsView from './views/resultsView.js';
import paginationView from './views/paginationView.js';
import bookmarksView from './views/bookmarksView.js';
import addRecipeView from './views/addRecipeView.js';
import { MODAL_CLOSE_SEC } from './config.js';
import { async } from 'regenerator-runtime';

// import 'core-js/stable';
// import 'regenerator-runtime/runtime';

const recipeContainer = document.querySelector('.recipe');

// NEW API URL (instead of the one shown in the video)
// https://forkify-api.jonas.io

///////////////////////////////////////
if (module.hot) {
  module.hot.accept();
}

const controlRecipe = async function () {
  try {
    const id = window.location.hash.slice(1);
    if (!id) return;
    recipeView.renderSpinner();
    resultsView.update(model.loadSearchResultsPage());
    bookmarksView.update(model.state.bookmarks);
    await model.loadRecipe(id);
    recipeView.render(model.state.recipe);
  } catch (e) {
    recipeView.renderError();
    console.error(e);
  }
};
const controlSearchResults = async function () {
  try {
    const query = searchView.getQuery();
    if (!query) return;
    resultsView.renderSpinner();
    await model.loadSearchResults(query);
    resultsView.render(model.loadSearchResultsPage());

    paginationView.render(model.state.search);
  } catch (e) {
    resultsView.renderError();
    console.error(e);
  }
};
const controlPagination = function (page) {
  resultsView.render(model.loadSearchResultsPage(page));
  paginationView.render(model.state.search);
};
const controlServing = function (servings) {
  model.updateServings(servings);
  recipeView.update(model.state.recipe);
};
const controlAddBookmark = function () {
  if (!model.state.recipe.bookmarked) model.addBookmarks(model.state.recipe);
  else model.deleteBookmarks(model.state.recipe.id);
  recipeView.update(model.state.recipe);
  // if (model.state.bookmarks.length === 0) bookmarksView.renderError();
  bookmarksView.render(model.state.bookmarks);
};
const controlBookmark = function () {
  bookmarksView.render(model.state.bookmarks);
};
const controlAddRecipe = async function (recipe) {
  try {
    addRecipeView.renderSpinner();
    await model.addRecipe(recipe);
    addRecipeView.renderMessage();
    window.history.pushState(null, '', `#${model.state.recipe.id}`);
    model.addBookmarks(model.state.recipe);
    bookmarksView.render(model.state.bookmarks);
    recipeView.renderSpinner();
    recipeView.render(model.state.recipe);
    setTimeout(addRecipeView.hideWindow(), MODAL_CLOSE_SEC * 1000);
  } catch (e) {
    addRecipeView.renderError(e);
    console.error(e);
  }
};
const init = function () {
  bookmarksView.addHandlerRender(controlBookmark);
  recipeView.addHandlerRender(controlRecipe);
  recipeView.addHandelUpdateServing(controlServing);
  recipeView.addHandelAddBookmark(controlAddBookmark);
  searchView.addHandlerSearch(controlSearchResults);
  paginationView.addHandlerClick(controlPagination);
  addRecipeView.addHandlerForm(controlAddRecipe);
};
init();
